var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"primary pa-6 d-flex justify-center"},[_c('a',{attrs:{"href":"https://mgpapelaria.com.br/","target":"_blank"}},[_c('img',{attrs:{"src":"/img/logo.svg"}})])])
}]

export { render, staticRenderFns }